export default function getLevel({
  CampaignId,
  AdGroupId,
}) {
  if (AdGroupId) {
    return 'AdGroup';
  } else if (CampaignId) {
    return 'Campaign';
  }

  return 'Account'; // TODO: for AccountsSummary
}
